module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-Bold.ae8f19f4.otf";